import {
  createContext,
  useContext,
  useEffect,
  useState,
  type ReactNode,
} from "react";
import type { Lang } from "./domain";
type Locale = {
  lang: Lang;
  setLang: (v: Lang) => void;
  w: (ar: string, en: string) => string;
};
const LocaleContext = createContext<Locale | null>(null);
export function LocaleProvider({ children }: { children: ReactNode }) {
  const [lang, setLang] = useState<Lang>(() => {
    const value =
      new URLSearchParams(location.search).get("lang") ||
      localStorage.getItem("mzn-admin-language");
    return value === "en" ? "en" : "ar";
  });
  useEffect(() => {
    document.documentElement.lang = lang;
    document.documentElement.dir = lang === "ar" ? "rtl" : "ltr";
    localStorage.setItem("mzn-admin-language", lang);
    document.title =
      lang === "ar" ? "مَزَن | مركز الإدارة" : "MZN | Admin workspace";
  }, [lang]);
  return (
    <LocaleContext
      value={{ lang, setLang, w: (ar, en) => (lang === "ar" ? ar : en) }}
    >
      {children}
    </LocaleContext>
  );
}
export function useLocale() {
  const value = useContext(LocaleContext);
  if (!value) throw new Error("Missing locale provider");
  return value;
}
